@if (selectedBuilding) { @if(isMobileView) {
<section id="project" class="p-2 p-lg-0">
    <div class="d-flex flex-column justify-content-center p-2">
        <app-project-detail [project]="project"></app-project-detail>
        <h1 class="my-3">{{ 'PROJECT_BUILDINGS' | translate }}</h1>
        @if(buildings.length > 0) {
        <div class="d-flex pb-3 align-items-center">
            <ng-container [ngTemplateOutlet]="buildingSearchTpl"></ng-container>
            <ng-container [ngTemplateOutlet]="addBuildingTpl"></ng-container>
        </div>
        <ng-container [ngTemplateOutlet]="buildingListTpl"></ng-container>
        }
        <div class="d-flex mb-3">
            @if (plannedPlannings.length > 0 || drafts.length > 0) {
            <a [class.active]="mobileShowPlanned" class="tab-item" (click)="mobileShowPlanned = true">
                <h2>
                    <fa-icon class="me-2" [icon]="['fal', 'screwdriver-wrench']"></fa-icon>
                    {{ 'BUILDING_MODULES_PLANNED' | translate }}
                </h2>
            </a>
            }
            <a [class.active]="!mobileShowPlanned" class="tab-item" (click)="mobileShowPlanned = false">
                <h2>
                    <fa-icon class="me-2" [icon]="['fal', 'plus']"></fa-icon>
                    {{ 'PROJECT_NEW_CONFIGURATION' | translate }}
                </h2>
            </a>
        </div>
        @if(mobileShowPlanned) {
        <ng-container [ngTemplateOutlet]="plannedPlanningsTpl"></ng-container>
        } @else {
        <ng-container [ngTemplateOutlet]="importBtnTpl"></ng-container>
        <ng-container [ngTemplateOutlet]="unplannedPlanningsTpl"></ng-container>
        }
    </div>
</section>
} @else {
<section id="project" class="no-padding">
    <div class="row">
        <div class="col-lg-7">
            <ng-container [ngTemplateOutlet]="returnToDashboardBtnTpl"></ng-container>
        </div>
        <div class="col-lg-5 bg-white"></div>
    </div>
    <div class="row content">
        <div class="col-lg-7 h-100">
            <div class="grid-padding d-flex">
                <div class="col-5 col-xxxl-3 pe-3">
                    <h3 class="mb-3">{{ 'PROJECT_BUILDINGS' | translate }}</h3>
                    @if (buildings.length > 0) {
                    <ng-container [ngTemplateOutlet]="buildingSearchTpl"></ng-container>
                    <ng-container [ngTemplateOutlet]="buildingListTpl"></ng-container>
                    }
                </div>
                <div class="plannings col-7 col-xxxl-9">
                    <div class="app-project-detail">
                        <app-project-detail [project]="project"></app-project-detail>
                    </div>
                    <ng-container [ngTemplateOutlet]="plannedPlanningsTpl"></ng-container>
                </div>
            </div>
        </div>
        <div class="col-lg-5 bg-white h-100">
            <div class="grid-padding">
                <div class="d-flex justify-content-between align-items-center">
                    <h2 class="fw-bold">{{ 'BUILDING_MODULES_UNPLANNED' | translate }}</h2>
                    <ng-container [ngTemplateOutlet]="importBtnTpl"></ng-container>
                </div>
                <ng-container [ngTemplateOutlet]="unplannedPlanningsTpl"></ng-container>
            </div>
        </div>
    </div>
</section>
} }@else { @if(!isMobileView) {
<ng-container [ngTemplateOutlet]="returnToDashboardBtnTpl"></ng-container>
}
<div class="d-flex flex-column align-items-center empty-state-container">
    <div class="w-50 flex-placeholder mt-3">
        <app-project-detail [project]="project"></app-project-detail>
    </div>
    <div class="empty-state">
        <div class="icon-container">
            <fa-icon [icon]="['fal', 'house-building']" size="4x"></fa-icon>
        </div>
        <h3 class="m-0">
            {{ 'PROJECT_NO_BUILDING_YET' | translate }}
        </h3>
        <p class="m-0">
            {{ 'PROJECT_CREATE_BUILDING_HINT' | translate }}
        </p>
        <button (click)="addBuilding()" class="btn btn-success add-building-btn">
            {{ 'PROJECT_ADD_BUILDING_LINK' | translate }}
            <fa-icon class="ms-3 me-0" [icon]="['fal', 'plus']" size="xl"></fa-icon>
        </button>
    </div>
    <div class="flex-placeholder"></div>
</div>
}

<input
    #planningImport
    class="d-none"
    accept="application/json"
    name="planningImport"
    id="planningImport"
    type="file"
    (change)="checkIfPlanningIsImportable($event)" />

<ng-template #buildingListTpl>
    <div class="building-list hide-scrollbar d-flex flex-lg-column">
        @if(!isMobileView) {
        <ng-container [ngTemplateOutlet]="addBuildingTpl"></ng-container>
        } @for (building of filteredBuildings; track building.id) {
        <app-building-card
            [building]="building"
            [projectId]="project.id"
            [regions]="regions"
            [selected]="selectedBuilding.id === building.id"
            (selectedChange)="selectedBuilding = building; setPlannings()"
            (buildingChange)="reloadBuildings($event)"></app-building-card>
        }
        <div class="pseudo"></div>
    </div>
</ng-template>

<ng-template #addBuildingTpl>
    <div class="add-building-card" (click)="addBuilding()">
        <fa-icon class="add-building-icon" size="xl" [icon]="['fal', 'plus']"></fa-icon>
        <h3 class="d-none d-lg-block m-0">{{ 'BUILDING_NEW' | translate }}</h3>
    </div>
</ng-template>

<ng-template #plannedPlanningsTpl>
    <div class="flex-grow-1 hide-scrollbar overflow-auto">
        @if (selectedBuilding) { @if(plannedPlannings.length > 0) { @if (!isMobileView) {
        <h2>
            <strong>{{ 'BUILDING_MODULES_PLANNED' | translate }}</strong>
        </h2>
        }
        <div class="card-list">
            @for (planning of plannedPlannings; track planning.moduleId) {
            <app-planning-card
                [planning]="planning"
                [buildingId]="selectedBuilding.id"
                [projectId]="project.id"
                [isMobile]="isMobileView"
                (configuratorNonMobile)="openWarningModal()"
                (planningDeleted)="deletePlanning($event); reloadBuildings()"></app-planning-card>

            }
            <div class="pseudo"></div>
        </div>
        } @if (drafts.length > 0) {
        <h2>
            <strong>{{ 'DRAFTS_TITLE' | translate }}</strong>
        </h2>
        <div class="card-list">
            @for (draft of drafts; track draft.moduleId) {
            <app-planning-card
                [isDraft]="true"
                [planning]="draft"
                [buildingId]="selectedBuilding.id"
                [projectId]="project.id"
                [isMobile]="isMobileView"
                (configuratorNonMobile)="openWarningModal()"
                (openDetails)="openDetails($event, true)"></app-planning-card>

            }
            <div class="pseudo"></div>
        </div>
        } }
    </div>
</ng-template>

<ng-template #unplannedPlanningsTpl>
    <div class="card-list unplanned-plannings hide-scrollbar">
        @for(planning of unplannedPlannings; track planning.moduleId) {
        <app-planning-card
            [planning]="planning"
            [buildingId]="selectedBuilding.id"
            [projectId]="project.id"
            [isMobile]="isMobileView"
            (configuratorNonMobile)="openWarningModal()"
            (openDetails)="openDetails($event)"></app-planning-card>
        }
    </div>
</ng-template>

<ng-template #buildingSearchTpl>
    <div class="building-search mb-lg-3 w-100">
        <input
            id="building-search"
            class="form-control"
            [attr.placeholder]="'SHARED_SEARCH_DOTS' | translate"
            (input)="filterBuildings($event.target.value)" />
        <span class="icon">
            <fa-icon [icon]="['fal', 'magnifying-glass']"></fa-icon>
        </span>
    </div>
</ng-template>

<ng-template #importBtnTpl>
    <div class="import-btn" ngbDropdown #dropdown="ngbDropdown">
        <button class="btn btn-success px-3 py-2" ngbDropdownToggle>
            <fa-icon class="me-2" [icon]="['fal', dropdown._open ? 'angle-up' : 'angle-down']" size="xl"></fa-icon>
            {{ 'BUILDING_PLANNING_IMPORT' | translate }}
        </button>
        <div ngbDropdownMenu class="p-0">
            @for (planning of selectedBuilding.plannings; track planning.moduleId) { @if
            (moduleAllowsImportExport(planning.moduleId)) {
            <button class="d-flex p-3" ngbDropdownItem (click)="planningToImport = planning.name; planningImport.click()">
                <shd-module-icon placement="left" [moduleName]="planning.name" [color]="'black'" [size]="'xl'"></shd-module-icon>
                <span class="ms-3">{{ 'BUILDING_MODULES_' + planning.name | uppercase | translate }}</span>
            </button>
            } }
        </div>
    </div>
</ng-template>

<ng-template #returnToDashboardBtnTpl>
    <button class="btn btn-return-to-dashboard" uiSref="dashboard">
        <fa-icon [icon]="['fal', 'arrow-left']" class="me-2"></fa-icon>
        {{ 'SHD_BACK_TO_DASHBOARD' | translate }}
    </button>
</ng-template>

<shd-confirm-modal [title]="'BUILDING_PLANNING_IMPORT' | translate" (confirmed)="createBuildingAndImportPlanning()">
    <ng-template shdConfirmModalQuestion>
        <shd-infobox [headerText]="'BUILDING_PLANNING_IMPORT_HINT' | translate"></shd-infobox>
        <p class="mt-4">
            {{
                'BUILDING_PLANNING_IMPORT_QUESTION'
                    | translate
                    | stringFormat : [selectedBuilding.name, 'BUILDING_MODULES_' + planningToImport | uppercase | translate]
            }}
        </p>
    </ng-template>
</shd-confirm-modal>

<shd-desktop-only-modal #desktopOnlyModalTpl></shd-desktop-only-modal>
<app-configurator-detail-bar></app-configurator-detail-bar>
